export const TYPES = {
  COMPANY: 'company',
  WAREHOUSE: 'warehouse',
  LOCATION:'location',
  UNIT: 'unit'
}
